export const LOGIN = "/login";
export const SSOLOGIN = "/iam/login/login";
export const Logout = "/logout";
export const REFRESH_TOKEN = "/oauth/refreshToken";
export const Users = "/user";
export const Roles = "/roles";
export const Menus = "/config/menus";
export const Regions = "/config/regions";